var _path, _path2, _path3, _rect, _circle, _rect2, _path4, _path5, _path6, _rect3, _rect4, _path7, _rect5, _rect6, _rect7, _rect8, _path8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _path9, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _path10, _path11, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup5981(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 167,
    viewBox: "0 0 168 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.26698 29.4207C5.47699 25.3285 8.17493 21.377 12.2739 20.6229L107.905 3.02856C109.252 2.78073 110.547 3.6629 110.81 5.00702L136.239 134.905C137.242 140.03 133.921 145.003 128.803 146.041L35.0209 165.056C33.6588 165.333 32.3329 164.445 32.0695 163.08L6.26698 29.4207Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26698 29.4207C5.47699 25.3285 8.17493 21.377 12.2739 20.6229L107.905 3.02856C109.252 2.78073 110.547 3.6629 110.81 5.00702L136.239 134.905C137.242 140.03 133.921 145.003 128.803 146.041L35.0209 165.056C33.6588 165.333 32.3329 164.445 32.0695 163.08L6.26698 29.4207Z",
    fill: "url(#paint0_linear_1251_40)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26698 29.4207C5.47699 25.3285 8.17493 21.377 12.2739 20.6229L107.905 3.02856C109.252 2.78073 110.547 3.6629 110.81 5.00702L136.239 134.905C137.242 140.03 133.921 145.003 128.803 146.041L35.0209 165.056C33.6588 165.333 32.3329 164.445 32.0695 163.08L6.26698 29.4207Z",
    stroke: "#0A7F69"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.83205,
    y: 20.9876,
    width: 102.359,
    height: 139.534,
    rx: 2.5,
    transform: "rotate(-10.9263 9.83205 20.9876)",
    fill: "white",
    stroke: "#0A7F69"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52.679,
    cy: 19.505,
    r: 3.13436,
    stroke: "#0A7F69"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 57.8877,
    y: 17.4351,
    width: 13.9317,
    height: 0.605727,
    transform: "rotate(-10.3936 57.8877 17.4351)",
    fill: "#D9D9D9",
    stroke: "#0A7F69",
    strokeWidth: 0.605727
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4167 140.65L24.8154 61.9058L23.6036 60.0886L39.9584 144.89C39.9584 148.283 43.9967 148.727 46.0158 148.525L88.4167 140.65Z",
    fill: "#DBFFF7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3533 141.256L18.7585 34.6481C17.448 27.864 20.2316 26.168 21.7872 26.1679L42.9876 22.5336L46.622 27.3794L78.1198 21.3221V15.2649C85.3885 14.0534 100.411 11.5094 102.349 11.0248C104.287 10.5402 105.176 14.0534 105.378 15.8706C112.041 49.5894 125.73 118.723 127.184 125.507C128.092 129.747 126.578 133.584 125.367 133.382C100.128 137.622 49.298 148.136 45.4105 148.525C39.3533 149.131 39.959 144.487 39.3533 141.256Z",
    stroke: "#0A7F69"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.45 43.1282C35.113 40.7053 48.8024 38.2824 50.2561 47.974C52.679 60.5731 39.1511 62.5114 32.0843 61.9057V57.0599",
    stroke: "#DBFFF7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 82.2511,
    y: 30.9798,
    width: 20.3358,
    height: 0.851891,
    rx: 0.425945,
    transform: "rotate(-8.42407 82.2511 30.9798)",
    stroke: "#DBFFF7",
    strokeWidth: 0.851891
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 83.4628,
    y: 34.6142,
    width: 20.3358,
    height: 0.851891,
    rx: 0.425945,
    transform: "rotate(-8.42407 83.4628 34.6142)",
    stroke: "#DBFFF7",
    strokeWidth: 0.851891
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8953 90.4528C47.8548 90.2635 47.9748 90.077 48.1639 90.0355L93.0617 80.1799C93.2523 80.138 93.4405 80.2592 93.4813 80.4499C93.5218 80.6393 93.4017 80.8257 93.2126 80.8672L48.3148 90.7229C48.1243 90.7647 47.9361 90.6436 47.8953 90.4528Z",
    stroke: "#DBFFF7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 50.6436,
    y: 94.2796,
    width: 29.2065,
    height: 0.851891,
    rx: 0.425945,
    transform: "rotate(-12.0761 50.6436 94.2796)",
    stroke: "#DBFFF7",
    strokeWidth: 0.851891
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 37.5159,
    y: 75.4567,
    width: 53.4973,
    height: 0.851891,
    rx: 0.425945,
    transform: "rotate(-12.0761 37.5159 75.4567)",
    stroke: "#DBFFF7",
    strokeWidth: 0.851891
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 38.7276,
    y: 80.3025,
    width: 53.4973,
    height: 0.851891,
    rx: 0.425945,
    transform: "rotate(-12.0761 38.7276 80.3025)",
    stroke: "#DBFFF7",
    strokeWidth: 0.851891
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 43.1707,
    y: 84.457,
    width: 50.1929,
    height: 0.851891,
    rx: 0.425945,
    transform: "rotate(-12.0761 43.1707 84.457)",
    stroke: "#DBFFF7",
    strokeWidth: 0.851891
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6836 89.2414C46.6431 89.0521 46.7631 88.8656 46.9522 88.8241L91.8501 78.9684C92.0406 78.9266 92.2288 79.0478 92.2696 79.2385C92.3101 79.4278 92.1901 79.6143 92.001 79.6558L47.1031 89.5115C46.9126 89.5533 46.7244 89.4321 46.6836 89.2414Z",
    stroke: "#0A7F69"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 49.4319,
    y: 93.0681,
    width: 29.2065,
    height: 0.851891,
    rx: 0.425945,
    transform: "rotate(-12.0761 49.4319 93.0681)",
    stroke: "#0A7F69",
    strokeWidth: 0.851891
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 45.7979,
    y: 125.777,
    width: 4.91435,
    height: 0.851891,
    rx: 0.425945,
    transform: "rotate(-12.0761 45.7979 125.777)",
    stroke: "#0A7F69",
    strokeWidth: 0.851891
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 55.4893,
    y: 123.355,
    width: 4.91435,
    height: 0.851891,
    rx: 0.425945,
    transform: "rotate(-12.0761 55.4893 123.355)",
    stroke: "#0A7F69",
    strokeWidth: 0.851891
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 66.3924,
    y: 120.932,
    width: 4.91435,
    height: 0.851891,
    rx: 0.425945,
    transform: "rotate(-12.0761 66.3924 120.932)",
    stroke: "#0A7F69",
    strokeWidth: 0.851891
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 77.2954,
    y: 118.509,
    width: 4.91435,
    height: 0.851891,
    rx: 0.425945,
    transform: "rotate(-12.0761 77.2954 118.509)",
    stroke: "#0A7F69",
    strokeWidth: 0.851891
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 89.4099,
    y: 116.086,
    width: 4.91435,
    height: 0.851891,
    rx: 0.425945,
    transform: "rotate(-12.0761 89.4099 116.086)",
    stroke: "#0A7F69",
    strokeWidth: 0.851891
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 99.1018,
    y: 113.663,
    width: 6.12581,
    height: 0.851891,
    rx: 0.425945,
    transform: "rotate(-12.0761 99.1018 113.663)",
    stroke: "#0A7F69",
    strokeWidth: 0.851891
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 108.793,
    y: 111.24,
    width: 7.33726,
    height: 0.851891,
    rx: 0.425945,
    transform: "rotate(-12.0761 108.793 111.24)",
    stroke: "#0A7F69",
    strokeWidth: 0.851891
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2383 41.9167C33.9013 39.4938 47.5907 37.0709 49.0445 46.7626C51.4674 59.3617 37.9395 61.3 30.8726 60.6942V55.8484",
    stroke: "#0A7F69"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 81.0399,
    y: 29.7684,
    width: 20.3358,
    height: 0.851891,
    rx: 0.425945,
    transform: "rotate(-8.42407 81.0399 29.7684)",
    stroke: "#0A7F69",
    strokeWidth: 0.851891
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 82.2511,
    y: 33.4028,
    width: 20.3358,
    height: 0.851891,
    rx: 0.425945,
    transform: "rotate(-8.42407 82.2511 33.4028)",
    stroke: "#0A7F69",
    strokeWidth: 0.851891
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 36.3047,
    y: 74.2453,
    width: 53.4973,
    height: 0.851891,
    rx: 0.425945,
    transform: "rotate(-12.0761 36.3047 74.2453)",
    stroke: "#0A7F69",
    strokeWidth: 0.851891
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 38.9094,
    y: 78.793,
    width: 52.0725,
    height: 0.851891,
    rx: 0.425945,
    transform: "rotate(-12.0761 38.9094 78.793)",
    stroke: "#0A7F69",
    strokeWidth: 0.851891
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 41.9588,
    y: 83.2455,
    width: 50.1929,
    height: 0.851891,
    rx: 0.425945,
    transform: "rotate(-12.0761 41.9588 83.2455)",
    stroke: "#0A7F69",
    strokeWidth: 0.851891
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 54.8939,
    y: 134.376,
    width: 56.7259,
    height: 6.05168,
    rx: 2.41042,
    transform: "rotate(-10.8695 54.8939 134.376)",
    fill: "url(#paint1_linear_1251_40)",
    stroke: "#0A7F69"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9186 97.6437C51.8709 97.2398 43.1081 100.188 48.4385 115.21C51.8081 124.706 60.3578 119.695 68.3341 111.561C69.0877 110.792 70.0544 110.235 71.1301 110.198C73.5959 110.113 76.9588 110.685 78.1193 113.393C80.0577 117.269 87.0033 110.97 90.2339 107.335C91.8492 106.326 96.7757 104.549 103.56 105.518",
    stroke: "#0A7F69"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M102.349 107.335C102.834 101.52 106.589 95.2209 108.406 92.798C120.117 78.2605 144.871 47.7319 150.201 41.9169C156.864 34.6482 159.287 30.4081 164.739 32.2253C169.1 33.679 166.556 38.8883 164.739 41.3112L122.338 92.798C115.473 100.067 101.864 113.15 102.349 107.335Z",
    fill: "#DBFFF7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M110.829 95.2208L151.413 44.9454M104.772 91.5864C102.955 94.0093 99.1991 100.309 98.7145 106.124C98.2299 111.939 111.839 98.8551 118.704 91.5864L161.104 40.0996C162.921 37.6767 165.465 32.4674 161.104 31.0137C155.653 29.1965 153.23 33.4366 146.567 40.7053C141.236 46.5203 116.482 77.049 104.772 91.5864Z",
    stroke: "#0A7F69"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1251_40",
    x1: 25.5967,
    y1: 144.626,
    x2: 146.209,
    y2: 164.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ECBA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#169C83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1251_40",
    x1: 66.6294,
    y1: 137.248,
    x2: 127.691,
    y2: 137.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ECBA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#128774"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup5981);
export default __webpack_public_path__ + "static/media/Group 5981.00241843e839bfe1d71a6e6d59d30e16.svg";
export { ForwardRef as ReactComponent };